module.exports = __webpack_public_path__ + "media/src/images/people_search_clipart-51af759690c19ba5dbb8b188d9ec3bae.svg";